var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "@/lib/utils";
import { NumericFormat } from "react-number-format";
var InputNumeric = React.forwardRef(function (_a, ref) {
    var className = _a.className, type = _a.type, thousandSeparator = _a.thousandSeparator, decimalSeparator = _a.decimalSeparator, decimalScale = _a.decimalScale, fixedDecimalScale = _a.fixedDecimalScale, props = __rest(_a, ["className", "type", "thousandSeparator", "decimalSeparator", "decimalScale", "fixedDecimalScale"]);
    return (_jsx(NumericFormat, __assign({ type: type, thousandSeparator: thousandSeparator, decimalSeparator: decimalSeparator, decimalScale: decimalScale, fixedDecimalScale: fixedDecimalScale, className: cn("flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50", className), inputRef: ref }, props)));
});
InputNumeric.displayName = "InputNumeric";
export { InputNumeric };
